import * as React from "react";
import { AlgoliaProviders } from "./AlgoliaProviders.js";
import { VirtualFacets } from "../components/VirtualFacets/Algolia/components/VirtualFacets/VirtualFacets.js";
const AlgoliaServerState = () => {
  return /* @__PURE__ */ React.createElement(AlgoliaProviders, null, /* @__PURE__ */ React.createElement(VirtualFacets, null));
};
export {
  AlgoliaServerState
};
//# sourceMappingURL=AlgoliaServerState.js.map
